// extracted by mini-css-extract-plugin
export default {"link":"NavigationToken_link__ylndS","token":"NavigationToken_token__HMSW2"};